import { api } from "../utils/api";
import type { RestStockLocation } from "@KassaroAB/shared/types/stockLocation";
import type { ChainId } from "@KassaroAB/shared/types/ids";

export const getStockLocationsApi = (
  chainId: ChainId,
): Promise<RestStockLocation[]> => {
  return api.get(`chains/${chainId}/stockLocations`);
};
